import { NgModule } from '@angular/core';
import { MarkerIO } from './marker-io';

@NgModule({
    providers: [
        {
            provide: MarkerIO,
        }
    ]
})
export class MarkerIOModule {
    constructor(markerIo: MarkerIO){}
}
